import { render } from "./CreateFolderModal.vue?vue&type=template&id=14a92bfb"
import script from "./CreateFolderModal.vue?vue&type=script&lang=js"
export * from "./CreateFolderModal.vue?vue&type=script&lang=js"
script.render = render

export default script